export default "__VITE_ASSET__F6UFb0QF__"